import { createFileRoute } from "@tanstack/react-router";

import DashboardSkeleton from "@/components/loadings/skeleton/DashboardSkeleton";
import type { ChildRouteContext } from "@/root";

import Dashboard from "../../../components/Dashboard";

export const Route = createFileRoute("/_panel/_core/")({
  component: Component,
  pendingComponent: DashboardSkeleton,
  beforeLoad: ({ context }) =>
    ({
      title: () => context.t("Dashboard", { ns: "core.shared" }),
      hideCrumb: true,
    }) satisfies ChildRouteContext,
});

function Component() {
  return <Dashboard />;
}
